/*
 * CMP-022 Toast — Phase A1. No dependencies. Feedback surface for reversible actions (SCR-015: "Actividad eliminada del
 * historial" + "Deshacer").
 *   NcToast.show({ tone: 'success'|'error', message, detail?, actionLabel?, actionId?, duration? })
 * returns the toast element. It never steals focus; the region is a polite live region (assertive for errors), so the
 * message is announced once. Escape on a focused toast dismisses it. Auto-dismiss: `duration` ms (PROPOSED default 8000
 * when there is an action, 5000 otherwise; Figma does not specify it); 0 keeps it until dismissed. The timer pauses
 * while the pointer or focus is on the toast (WCAG 2.2.1), so the action is never missed.
 * Events (bubbling from the toast): `nc-toast:action` {id}, `nc-toast:dismiss` {reason: 'action'|'close'|'timeout'|'escape'|'api'}.
 */
(function () {
  if (typeof window !== 'undefined' && window.NcToast) return;

  function defaultDuration(hasAction) { return hasAction ? 8000 : 5000; }

  if (typeof module !== 'undefined' && module.exports) module.exports = { defaultDuration: defaultDuration };
  if (typeof document === 'undefined') return;

  var ICON_ERROR = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/></svg>';
  var ICON_OK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20 6 9 17l-5-5"/></svg>';
  var ICON_CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M18 6 6 18M6 6l12 12"/></svg>';

  // one fixed stack holds both live regions; they exist from page load so screen readers register them before the first toast
  function region(assertive) {
    var stack = document.getElementById('nc-toast-stack');
    if (!stack) {
      stack = document.createElement('div');
      stack.id = 'nc-toast-stack';
      stack.className = 'nc-toast-stack';
      document.body.appendChild(stack);
      [['nc-toast-region', 'status', 'polite'], ['nc-toast-region-assertive', 'alert', 'assertive']].forEach(function (def) {
        var el = document.createElement('div');
        el.id = def[0];
        el.className = 'nc-toast-region';
        el.setAttribute('role', def[1]);
        el.setAttribute('aria-live', def[2]);
        stack.appendChild(el);
      });
    }
    return document.getElementById(assertive ? 'nc-toast-region-assertive' : 'nc-toast-region');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { region(false); });
  else region(false);

  function text(tag, cls, value) {
    var el = document.createElement(tag);
    el.className = cls;
    el.textContent = value;
    return el;
  }

  window.NcToast = {
    show: function (options) {
      var tone = options.tone === 'error' ? 'error' : 'success';
      var toast = document.createElement('div');
      toast.className = 'nc-toast nc-toast--' + tone;
      var icon = document.createElement('span');
      icon.className = 'nc-toast__icon';
      icon.innerHTML = tone === 'error' ? ICON_ERROR : ICON_OK;
      toast.appendChild(icon);
      var copy = document.createElement('div');
      copy.className = 'nc-toast__copy';
      copy.appendChild(text('p', 'nc-toast__message', options.message));
      if (options.detail) copy.appendChild(text('p', 'nc-toast__detail', options.detail));
      toast.appendChild(copy);

      var timer = null;
      var remaining = options.duration === undefined ? defaultDuration(!!options.actionLabel) : options.duration;
      var started = 0;
      var dismissed = false;
      var lastFocus = null;

      function dismiss(reason) {
        if (dismissed) return;
        dismissed = true;
        clearTimeout(timer);
        // dismissing with focus inside must not drop focus on <body>: give it back to where it came from
        if (toast.contains(document.activeElement) && lastFocus && lastFocus.isConnected) lastFocus.focus();
        toast.dispatchEvent(new CustomEvent('nc-toast:dismiss', { bubbles: true, detail: { reason: reason } }));
        toast.remove();
      }
      function start() {
        if (!remaining) return;
        started = Date.now();
        timer = setTimeout(function () { dismiss('timeout'); }, remaining);
      }
      function pause() {
        if (!timer) return;
        clearTimeout(timer);
        timer = null;
        remaining = Math.max(1000, remaining - (Date.now() - started));
      }

      if (options.actionLabel) {
        var action = text('button', 'nc-toast__action', options.actionLabel);
        action.type = 'button';
        action.addEventListener('click', function () {
          toast.dispatchEvent(new CustomEvent('nc-toast:action', { bubbles: true, detail: { id: options.actionId || 'action' } }));
          dismiss('action');
        });
        toast.appendChild(action);
      }
      var close = document.createElement('button');
      close.type = 'button';
      close.className = 'nc-toast__close';
      close.setAttribute('aria-label', options.closeLabel || 'Cerrar aviso');
      close.innerHTML = ICON_CLOSE;
      close.addEventListener('click', function () { dismiss('close'); });
      toast.appendChild(close);

      toast.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') { event.preventDefault(); dismiss('escape'); }
      });
      toast.addEventListener('mouseenter', pause);
      toast.addEventListener('focusin', function (event) {
        if (event.relatedTarget && !toast.contains(event.relatedTarget)) lastFocus = event.relatedTarget;
        pause();
      });
      toast.addEventListener('mouseleave', function () { if (!dismissed && !timer) start(); });
      toast.addEventListener('focusout', function (event) { if (!toast.contains(event.relatedTarget) && !dismissed && !timer) start(); });
      toast.dismiss = function () { dismiss('api'); };

      region(tone === 'error').appendChild(toast);
      start();
      return toast;
    }
  };
})();
